import { QueueItem } from 'core-utilities';
import thumbnailRequester from '../util/thumbnailRequester';
import thumbnailHanders from '../util/thumbnailHandler';

import {
  ThumbnailTypes,
  ThumbnailStates,
  ThumbnailAssetsSize,
  ThumbnailGameIconSize,
  ThumbnailGamePassIconSize,
  ThumbnailGameThumbnailSize,
  ThumbnailUniverseThumbnailSize,
  ThumbnailGroupIconSize,
  ThumbnailBadgeIconSize,
  ThumbnailDeveloperProductIconSize,
  ThumbnailAvatarsSize,
  ThumbnailFormat,
  ThumbnailAvatarHeadshotSize,
  ThumbnailQueueItem
} from '../constants/thumbnail2dConstant';

const { batchRequestHandler, universeThumbnailHandler } = thumbnailHanders;

const { processThumbnailBatchRequest } = thumbnailRequester;

const loadThumbnailImage = (
  thumbnailType: ThumbnailTypes,
  targetId: number,
  size:
    | ThumbnailAssetsSize
    | ThumbnailGameIconSize
    | ThumbnailGameThumbnailSize
    | ThumbnailUniverseThumbnailSize
    | ThumbnailGamePassIconSize
    | ThumbnailAvatarsSize
    | ThumbnailAvatarHeadshotSize
    | ThumbnailGroupIconSize
    | ThumbnailBadgeIconSize
    | ThumbnailDeveloperProductIconSize,
  format: ThumbnailFormat = ThumbnailFormat.jpeg,
  clearCachedValue?: boolean
) => {
  if (!targetId) {
    return new Promise((resolve, reject) => {
      reject(new Error('TargetId can not be empty.'));
    });
  }

  if (!thumbnailType) {
    return new Promise((resolve, reject) => {
      reject(new Error('ThumbnailType can not be empty.'));
    });
  }
  const item = {
    targetId,
    type: thumbnailType,
    format,
    size
  };
  const customHandler = [ThumbnailTypes.universeThumbnails, ThumbnailTypes.universeThumbnail];
  // null requesterKey creates new batch request processor.
  const requesterKey = !customHandler.includes(thumbnailType) ? 'thumbnail2dProcessor' : null;
  return processThumbnailBatchRequest(
    item,
    (items: Array<QueueItem<ThumbnailQueueItem>>) => {
      if (thumbnailType === ThumbnailTypes.universeThumbnail) {
        return universeThumbnailHandler.handle(items, 1);
      }

      if (thumbnailType === ThumbnailTypes.universeThumbnails) {
        return universeThumbnailHandler.handle(items, 10);
      }

      return batchRequestHandler.handle(items);
    },
    requesterKey,
    clearCachedValue
  );
};

const getThumbnailImage = (
  thumbnailType: ThumbnailTypes,
  targetId: number,
  size:
    | ThumbnailAssetsSize
    | ThumbnailGameIconSize
    | ThumbnailGameThumbnailSize
    | ThumbnailUniverseThumbnailSize
    | ThumbnailGamePassIconSize
    | ThumbnailAvatarsSize
    | ThumbnailAvatarHeadshotSize
    | ThumbnailGroupIconSize
    | ThumbnailBadgeIconSize
    | ThumbnailDeveloperProductIconSize,
  format: ThumbnailFormat = ThumbnailFormat.jpeg
) => {
  return loadThumbnailImage(thumbnailType, targetId, size, format, false);
};

const reloadThumbnailImage = (
  thumbnailType: ThumbnailTypes,
  targetId: number,
  size:
    | ThumbnailAssetsSize
    | ThumbnailGameIconSize
    | ThumbnailGameThumbnailSize
    | ThumbnailUniverseThumbnailSize
    | ThumbnailGamePassIconSize
    | ThumbnailAvatarsSize
    | ThumbnailAvatarHeadshotSize
    | ThumbnailGroupIconSize
    | ThumbnailBadgeIconSize
    | ThumbnailDeveloperProductIconSize,
  format: ThumbnailFormat = ThumbnailFormat.jpeg
) => {
  return loadThumbnailImage(thumbnailType, targetId, size, format, true);
};

const getCssClass = (thumbnailState: ThumbnailStates) => {
  return {
    'icon-broken': thumbnailState === ThumbnailStates.error,
    'icon-in-review': thumbnailState === ThumbnailStates.inReview,
    'icon-blocked': thumbnailState === ThumbnailStates.blocked,
    'icon-pending': thumbnailState === ThumbnailStates.pending
  };
};

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
export default window.RobloxThumbnails?.thumbnailService || {
  getThumbnailImage,
  getCssClass,
  reloadThumbnailImage
};
